import { PayloadAction, ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';
import { ITasksState } from '.';
import { api } from '../../api/api';
import { ITicketsBalances } from '../../model/user-info.interface';

export enum CheckJoinChannelTaskResult {
    NotSubscribed = 0,
    Subscribed = 1,
    PendingCheck = 2,
}

export interface ICheckJoinChannelResponse {
    taskId: number;
    result: CheckJoinChannelTaskResult;
    pendingDate?: number;
    tickets?: ITicketsBalances;
    balance?: number;
    exp?: number;    
    lastRewardDate?: number;
};

export const checkJoinChannelsTasks = createAsyncThunk<ICheckJoinChannelResponse, number>(
    'checkJoinChannelsTasks',
    async (taskId: number) => await api.tasks.checkJoinChannel(taskId)
);

const checkJoinTasksHandler = (builder: ActionReducerMapBuilder<ITasksState>) => {
    builder
        .addCase(checkJoinChannelsTasks.pending, (state: ITasksState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(checkJoinChannelsTasks.fulfilled, (state: ITasksState, action: PayloadAction<ICheckJoinChannelResponse>) => {
            state.loading = false;
    
            if (!action.payload) {
                state.error = 'Unable to check join channel task';
                return;
            }

            const { taskId, result, lastRewardDate, pendingDate } = action.payload;

            if (result === CheckJoinChannelTaskResult.NotSubscribed) {
                state.error = 'Не подписан';

                if (state.joinChannelTasks) {
                    const activeTasks = [...state.joinChannelTasks.activeTasks];
                    const activeTaskIndex = activeTasks.findIndex(task => task.taskId === taskId);

                    if (activeTaskIndex >= 0) {
                        activeTasks[activeTaskIndex] = {
                            ...activeTasks[activeTaskIndex],
                            linkOpened: false,
                        };
                        state.joinChannelTasks = {
                            ...state.joinChannelTasks,
                            activeTasks,
                        };
                    }
                }

                return;
            }
            
            if (!state.joinChannelTasks)
                return;
            
            const activeTasks = [...state.joinChannelTasks.activeTasks];
            const archiveTasks = [...(state.joinChannelTasks.archiveTasks || [])];
            
            const activeTaskIndex = activeTasks.findIndex(task => task.taskId === taskId);

            if (result === CheckJoinChannelTaskResult.PendingCheck) {
                activeTasks[activeTaskIndex] = {
                    ...activeTasks[activeTaskIndex],
                    result: CheckJoinChannelTaskResult.PendingCheck,
                    pendingDate,
                    linkOpened: false,
                };
                state.joinChannelTasks = {
                    ...state.joinChannelTasks,
                    activeTasks,
                };
                return;
            }
            
            if (activeTaskIndex >= 0) {
                const updatedTask = { 
                    ...activeTasks[activeTaskIndex], 
                    subscribed: result === CheckJoinChannelTaskResult.Subscribed,
                    lastRewardDate,
                };
                
                activeTasks.splice(activeTaskIndex, 1);
                archiveTasks.unshift(updatedTask);
                
                state.joinChannelTasks = {
                    activeTasks,
                    archiveTasks,
                };
            }
            else {
                const archiveTaskIndex = archiveTasks.findIndex(task => task.taskId === taskId);
                if (archiveTaskIndex >= 0) {
                    archiveTasks[archiveTaskIndex] = {
                        ...archiveTasks[archiveTaskIndex],
                        subscribed: result === CheckJoinChannelTaskResult.Subscribed,
                        lastRewardDate
                    };
                    
                    state.joinChannelTasks.archiveTasks = archiveTasks;
                }
            }
        })
        .addCase(checkJoinChannelsTasks.rejected, (state: ITasksState) => {
            state.loading = false;
            state.error = 'Unable to check join channel task';
        });
};

export default checkJoinTasksHandler;